var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import * as React from 'react';
export default React.memo(function (props) {
    return (React.createElement("svg", __assign({ width: 48, height: 48, viewBox: "0 0 48 48", xmlns: "http://www.w3.org/2000/svg" }, props),
        React.createElement("g", { stroke: "none", strokeWidth: 1, fill: "none", fillRule: "evenodd" },
            React.createElement("path", { fill: "none", d: "M0 0h48v48H0z" }),
            React.createElement("g", { fill: "currentColor" },
                React.createElement("path", { d: "M26.33 7.924l6.463 24.12a1.92 1.92 0 01-1.358 2.352L12.88 39.368a1.92 1.92 0 01-2.352-1.359L4.066 13.89a1.92 1.92 0 011.358-2.352l18.554-4.971a1.92 1.92 0 012.352 1.358zm-6.343 24.568l-7.42 1.989.496 1.855 7.422-1.989-.498-1.855zm8.283-6.196l-7.421 1.988 1.49 5.566 7.422-1.988-1.491-5.566zm-9.277 2.485l-7.421 1.989.497 1.855 7.421-1.988-.497-1.856zm8.034-7.124L10.33 26.132l.497 1.855 16.698-4.474-.497-1.856zm-.746-2.783L9.583 23.35l.497 1.855L26.78 20.73l-.498-1.856zm-2.485-9.276L7.098 14.072l1.74 6.494 16.698-4.475-1.74-6.493z" }),
                React.createElement("path", { d: "M29.63 12.883l12.215 3.272a1.729 1.729 0 011.222 2.117L37.25 39.98a1.729 1.729 0 01-2.117 1.222l-10.72-2.873 7.519-2.014.19-.056a3.842 3.842 0 002.526-4.649L29.63 12.883z" })))));
});
